<h1>input decorator and optional property</h1>

<h2>loop through entries</h2>

<app-entry *ngFor="let loopEntry of entries" [entry]="loopEntry"></app-entry>


<h2>empty entry</h2>

<app-entry></app-entry>
